import { Enclave } from './enclave';

export enum SourceType {
  PREMIUM_INTELLIGENCE = 'PREMIUM_INTELLIGENCE',
  INTERNAL = 'INTERNAL',
  OPEN_SOURCE_INTELLIGENCE = 'OPEN_SOURCE',
  OTHER = 'OTHER',
}

export enum SourceStatus {
  UP = 'UP',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
}

export type SourceWeight = 1 | 2 | 3 | 4 | 5;

export type Source = Enclave & {
  status?: SourceStatus,
  weight?: SourceWeight,
};
